// src/pages/farm/FarmMapSection.jsx
import React from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import FarmMapSytle from "../../../assets/stylesheets/farm-detail/sections/FarmMap.module.css";
import FarmDetailStyle from "../../../assets/stylesheets/farm-detail/FarmDetailPage.module.css";
import { MapLogo } from "../../../assets/logo/MapLogo";

import DetailGoogleMapComponent from "../../../components/common/map/DetailGoogleMap";
import Logger from "../../../utils/logger";

const log = Logger.create('FarmMap');

const mapContainerTitle = "Where your farm experience awaits";

export default function FarmMapSection({ location }) {

  const lat = parseFloat(location.latitude);
  const lng = parseFloat(location.longitude);

  const isMobile = window.innerWidth < 768;
  const coords = { lat, lng };
  const markers = [
    {
      id: location.id,
      position: coords,
      Component: MapLogo,
      onClick: () => log.log("Clicked on marker "),
      radius: 200
    }
  ];

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY
  });

  if (loadError) return <div>Map failed to load</div>;
  if (!isLoaded) return <div>Loading…</div>;

  return (
    <div
      className={`${FarmMapSytle["map-container"]}`}
    >
      <div className={FarmMapSytle["map-title-box"]}>
        <h2
          className={`${FarmDetailStyle["farmDetail-title"]} ${FarmMapSytle["map-title"]}`}
        >
          {mapContainerTitle}
        </h2>
      </div>

      <div className={FarmMapSytle["map-img"]}>
        <DetailGoogleMapComponent
          markers={markers}
          mapContainerStyle={{
            height: isMobile ? "300px" : "500px",
            width: "100%"
          }}
        />
      </div>
    </div>
  );
}
